import type {
  TrainingAssignment,
  TrainingComplianceState,
  TrainingStatus,
} from '../types/training.types';

export const TRAINING_STATUS_LABELS: Record<TrainingStatus, string> = {
  pending: 'Pending',
  in_progress: 'In progress',
  completed: 'Completed',
  locked: 'Locked',
};

export const TRAINING_COMPLIANCE_LABELS: Record<TrainingComplianceState, string> = {
  green: 'Compliant',
  yellow: 'Due',
  red: 'Non-compliant',
};

export function trainingTimeRemaining(dueAt: string, now = new Date()): string {
  const remainingMs = new Date(dueAt).getTime() - now.getTime();
  const days = Math.ceil(Math.abs(remainingMs) / 86_400_000);
  if (remainingMs < 0) return `${days} day${days === 1 ? '' : 's'} overdue`;
  if (days === 0) return 'Due today';
  return `${days} day${days === 1 ? '' : 's'} remaining`;
}

export function trainingProgress(assignment: TrainingAssignment): number {
  if (assignment.status === 'completed') return 100;
  const readWeight = assignment.readAttestedAt ? 50 : 0;
  if (!assignment.quizRequired) return readWeight;
  return readWeight + (assignment.quizPassedAt ? 50 : 0);
}

export function canSignTraining(assignment: TrainingAssignment): boolean {
  return assignment.status !== 'completed'
    && assignment.status !== 'locked'
    && Boolean(assignment.readAttestedAt)
    && (!assignment.quizRequired || Boolean(assignment.quizPassedAt));
}
